"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2386],{

/***/ 75417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30132);
/* harmony import */ var _app_components_Portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20901);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .dimmed {\n    position: fixed;\n    opacity: 0;\n    background: rgba(0, 0, 0, 0.7);\n    transition: opacity 0.15s ease-out;\n    z-index: 500;\n  }\n  .wrapper {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n    background: white;\n    transform: translateY(100%);\n    transition: transform 0.15s ease-out;\n    z-index: 500;\n  }\n  &.open {\n    .dimmed {\n      opacity: 1;\n      top: 0px;\n      left: 0px;\n      right: 0px;\n      bottom: 0px;\n    }\n    .wrapper {\n      transform: translateY(0%);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var BottomSheet = function(param) {
    var children = param.children, _open = param.open, open = _open === void 0 ? false : _open, onClose = param.onClose;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!open) return;
        if (typeof document !== "object") return;
        document.body.style.cssText = "\n        overflow: hidden;\n      ";
        return function() {
            document.body.style.cssText = "\n      ";
        };
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Portal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            className: "".concat(open ? "open" : ""),
            onClick: onClose,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "dimmed",
                    children: " "
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "wrapper",
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "header",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "close-btn",
                                children: " "
                            })
                        }),
                        children
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomSheet);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "BottomSheet__StyledWrapper",
    componentId: "sc-ca9da4d2-0"
})(_templateObject());


/***/ }),

/***/ 72715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: relative;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n\n    @keyframes spinner {\n      0% {\n        transform: rotate(0deg);\n      }\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes spinnerEase {\n      0% {\n        transform: rotate(0deg);\n      }\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n\n    .loading-spinner {\n      width: inherit;\n      height: inherit;\n      border: 3px solid ",
        ";\n      border-top: 3px solid ",
        ";\n      border-radius: 50%;\n      animation: spinner 1.2s ease-in-out infinite;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Loading = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "loading-spinner"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loading);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Loading__StyledWrapper",
    componentId: "sc-5bfb9b57-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), theme.background.bg_1, theme.color.primary_2);
});


/***/ }),

/***/ 96679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: ",
        ";\n    height: ",
        ";\n    background-color: rgba(0, 0, 0, 0.11);\n    border-radius: 4px;\n    animation: pulse 1.5s ease-in-out 0.5s infinite;\n\n    @keyframes pulse {\n      0% {\n        opacity: 1;\n      }\n      50% {\n        opacity: 0.4;\n      }\n      100% {\n        opacity: 1;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Skeleton = function(param) {
    var _width = param.width, width = _width === void 0 ? "auto" : _width, _height = param.height, height = _height === void 0 ? 16 : _height, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        width: width,
        height: height,
        className: className
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Skeleton);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Skeleton__StyledWrapper",
    componentId: "sc-62e13890-0"
})(_templateObject1(), function(param) {
    var width = param.width, height = param.height;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), typeof width === "number" ? "".concat(width, "px") : width, typeof height === "number" ? "".concat(height, "px") : height);
});


/***/ }),

/***/ 83821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #01a0ff;\n  text-decoration: underline;\n  margin-right: 10px;\n\n  &:hover {\n    color: #01a0ff;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var SnackbarLink = function(param) {
    var href = param.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
            target: "_blank",
            rel: "noreferrer",
            children: "보러가기"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SnackbarLink);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "SnackbarLink__StyledWrapper",
    componentId: "sc-264aa138-0"
})(_templateObject());


/***/ }),

/***/ 12163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ab": function() { return /* binding */ LIST_OFFSET_DEFAULT; },
/* harmony export */   "Qm": function() { return /* binding */ TEAM_RECRUIT_POST_BUTTON_VISIBLE_ACTIVITY_TYPE; },
/* harmony export */   "ep": function() { return /* binding */ TEAM_RECRUIT_VISIBLE_ACTIVITY_TYPE; },
/* harmony export */   "gH": function() { return /* binding */ CHAT_ROOM_JOINABLE_ACTIVITY_TYPE; },
/* harmony export */   "sC": function() { return /* binding */ LIST_LIMIT_DEFAULT; },
/* harmony export */   "z3": function() { return /* binding */ ACTIVITY_PAGE_TYPE; }
/* harmony export */ });
/* harmony import */ var constants_enums__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35460);

var LIST_OFFSET_DEFAULT = 0;
var LIST_LIMIT_DEFAULT = 10;
var ACTIVITY_PAGE_TYPE = constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .PageType.ACTIVITY */ .GV.ACTIVITY;
var CHAT_ROOM_JOINABLE_ACTIVITY_TYPE = [
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.CONTEST */ .kF.CONTEST,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION, 
];
var TEAM_RECRUIT_VISIBLE_ACTIVITY_TYPE = [
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, 
];
var TEAM_RECRUIT_POST_BUTTON_VISIBLE_ACTIVITY_TYPE = [
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, 
];


/***/ }),

/***/ 48354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .field-label {\n    font-size: 12px;\n    color: ",
        ";\n    margin-bottom: 11px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var FilterFieldWrapper = function(param) {
    var label = param.label, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "field-label",
                children: label
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FilterFieldWrapper);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FilterFieldWrapper__StyledWrapper",
    componentId: "sc-ccdb902c-0"
})(_templateObject(), function(props) {
    return props.theme.color.text_3;
});


/***/ }),

/***/ 75697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);
/* harmony import */ var _app_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85025);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 36px;\n  height: 36px;\n  border: 1px solid ",
        ";\n  padding: initial;\n  .reset-icon {\n    width: 18px;\n    height: 18px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ResetButton = function(param) {
    var onClick = param.onClick, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        color: "transparent",
        onClick: onClick,
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
            src: "/static/images/activity/reset.svg",
            className: "reset-icon"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ResetButton);
var StyledWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_app_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "ResetButton__StyledWrapper",
    componentId: "sc-16d22e50-0"
})(_templateObject(), function(props) {
    return props.theme.line.line_3;
});


/***/ }),

/***/ 36806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30132);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51384);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2416);
/* harmony import */ var swiper_css_grid__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_grid__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22546);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  padding-bottom: 50px;\n  max-width: 100%;\n  overflow: hidden;\n\n  .swiper-container {\n    overflow: visible;\n  }\n\n  .swiper-pagination-bullet,\n  .swiper-pagination-bullet-active {\n    width: 10px;\n    height: 10px;\n    background-color: black;\n    opacity: 0.25;\n  }\n\n  .swiper-pagination-bullet-active {\n    opacity: 0.75;\n  }\n\n  .swiper-item {\n    height: fit-content;\n  }\n\n  .swiper-pagination {\n    position: absolute;\n    bottom: -30px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var SlideWrapper = function(param) {
    var children = param.children, className = param.className;
    var pagination = {
        clickable: true,
        renderBullet: function(_, className) {
            return "<span class=".concat(className, "></span>");
        }
    };
    var slides = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(children);
    while(slides.length % 6 !== 0){
        slides.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}, "empty-".concat(slides.length)));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10,
            grid: {
                rows: 3,
                fill: "row"
            },
            pagination: pagination,
            modules: [
                swiper__WEBPACK_IMPORTED_MODULE_2__/* .Grid */ .rj,
                swiper__WEBPACK_IMPORTED_MODULE_2__/* .Pagination */ .tl
            ],
            className: "swiper-container",
            children: slides.map(function(childComponent, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                    className: "swiper-item",
                    children: childComponent
                }, index);
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SlideWrapper);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SlideWrapper__StyledWrapper",
    componentId: "sc-402ceedd-0"
})(_templateObject());


/***/ }),

/***/ 44608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);
/* harmony import */ var _app_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85025);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding: 13px;\n  font-size: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var SubmitButton = function(param) {
    var onClick = param.onClick, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        onClick: onClick,
        disabled: disabled,
        children: "선택 완료"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SubmitButton);
var StyledWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_app_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "SubmitButton__StyledWrapper",
    componentId: "sc-85ee9add-0"
})(_templateObject());


/***/ }),

/***/ 90021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53893);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: inline-flex;\n    cursor: pointer;\n    justify-content: space-between;\n    width: 100%;\n    padding: 11px 10px;\n    font-size: 13px;\n    font-weight: normal;\n    color: ",
        ";\n    background-color: ",
        ";\n\n    .left-label {\n      padding-left: 10px;\n      color: ",
        ";\n    }\n\n    .arrow-right {\n      width: 16px;\n      height: 16px;\n      padding: 2px;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var LeftItem = function(param) {
    var label = param.label, onClick = param.onClick, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        "data-is-active": isActive,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "left-label",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_2__/* .ArrowRight */ .ol, {
                className: "arrow-right"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LeftItem);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "LeftItem__StyledWrapper",
    componentId: "sc-a333eb15-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), theme.color.hint_1, theme.background.bg_3, theme.color.text_1);
});


/***/ }),

/***/ 37410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);
/* harmony import */ var components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36957);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: inline-flex;\n    justify-content: space-between;\n    width: 100%;\n    padding: 11px 15px;\n    font-size: 13px;\n    font-weight: normal;\n    color: ",
        ";\n    cursor: pointer;\n\n    .filter-count {\n      color: ",
        ";\n      margin-left: 2px;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var RightItem = function(param) {
    var label = param.label, filterCount = param.filterCount, onClick = param.onClick, endAdornment = param.endAdornment, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        "data-is-active": isActive,
        className: className,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                children: [
                    label,
                    filterCount !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                        className: "filter-count",
                        children: [
                            "(",
                            (0,components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_2__/* .getLimitNumText */ .i)({
                                number: filterCount,
                                limit: 999
                            }),
                            ")"
                        ]
                    })
                ]
            }),
            endAdornment
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RightItem);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "RightItem__StyledWrapper",
    componentId: "sc-172b3bbf-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), theme.color.text_1, theme.color.text_2);
});


/***/ }),

/***/ 59701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53893);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var CloseButton = function(param) {
    var onClick = param.onClick, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        onClick: onClick,
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseButton);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CloseButton__StyledWrapper",
    componentId: "sc-7ab48293-0"
})(_templateObject());


/***/ }),

/***/ 91202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29496);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47079);
/* harmony import */ var _app_components_SnackbarLink_SnackbarLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83821);
/* harmony import */ var _app_feature_activityDetail_constant_activity_constant__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12163);
/* harmony import */ var _app_feature_chatting_chattingContext_module_ChattingContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18944);
/* harmony import */ var _app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67235);
/* harmony import */ var components_LoginAlert__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39749);
/* harmony import */ var hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38405);
/* harmony import */ var hooks_useErrorSnackbar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96597);
/* harmony import */ var hooks_useFlutterInappwebview__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2165);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ActivityScrap_currentUser on User {\n    id\n    scrapCount\n  }\n\n  fragment ActivityScrap_activity on Activity {\n    id\n    isScrapped\n    scrapCount\n    activityTypeID\n    manager {\n      id\n      channel {\n        id\n        url\n        viewerHasFollowed\n      }\n    }\n    chatRoom {\n      id\n      viewerIsMember\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var ActivityScrap = function(props) {
    var activity = props.activity, children = props.children, refetchQueries = props.refetchQueries, update = props.update;
    var isWebview = (0,_app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_4__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var enqueueApolloError = (0,hooks_useErrorSnackbar__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)().enqueueApolloError;
    var joinChatRoom = (0,_app_feature_chatting_chattingContext_module_ChattingContext__WEBPACK_IMPORTED_MODULE_8__/* .useChattingContext */ .Y)().joinChatRoom;
    var fluterInappwebview = (0,hooks_useFlutterInappwebview__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)().fluterInappwebview;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showLoginAlert = ref[0], setShowLoginAlert = ref[1];
    var user = (0,hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_11__/* .useCurrentUserContext */ .O)().user;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useActivityScrapUpdateMutation */ .ha6)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
        onError: enqueueApolloError
    }, refetchQueries && {
        refetchQueries: refetchQueries,
        awaitRefetchQueries: true
    }), {
        update: update
    })), 2), activityScrapUpdate = ref1[0], loading = ref1[1].loading;
    var scrapCount = (activity === null || activity === void 0 ? void 0 : activity.scrapCount) || 0;
    var closeLoginAlert = function() {
        setShowLoginAlert(false);
    };
    var scrapActivity = function() {
        var ref, ref1, ref2;
        if (!(activity === null || activity === void 0 ? void 0 : activity.id)) {
            return;
        }
        if (!user) {
            setShowLoginAlert(true);
            return;
        }
        activityScrapUpdate({
            optimisticResponse: {
                __typename: "Mutation",
                activityScrapUpdate: {
                    __typename: "ActivityScrapUpdatePayload",
                    userScrap: {
                        id: "optimisticResponse_ID",
                        __typename: "UserScrap",
                        user: {
                            __typename: "User",
                            id: user.id,
                            scrapCount: ((user === null || user === void 0 ? void 0 : user.scrapCount) || 0) + ((activity === null || activity === void 0 ? void 0 : activity.isScrapped) ? -1 : 1),
                            scraps: []
                        }
                    },
                    activity: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, activity), {
                        id: activity.id,
                        isScrapped: !(activity === null || activity === void 0 ? void 0 : activity.isScrapped),
                        scrapCount: (activity.scrapCount || 0) + ((activity === null || activity === void 0 ? void 0 : activity.isScrapped) ? -1 : 1),
                        __typename: "Activity"
                    }),
                    scrapped: !(activity === null || activity === void 0 ? void 0 : activity.isScrapped)
                }
            },
            variables: {
                activityScrapUpdateInput: {
                    activityID: activity === null || activity === void 0 ? void 0 : activity.id,
                    referer: "/activity/".concat(activity === null || activity === void 0 ? void 0 : activity.id)
                },
                includeScrapUsers: false
            }
        });
        if (!activity.isScrapped && ((ref = activity.chatRoom) === null || ref === void 0 ? void 0 : ref.id) && _app_feature_activityDetail_constant_activity_constant__WEBPACK_IMPORTED_MODULE_7__/* .CHAT_ROOM_JOINABLE_ACTIVITY_TYPE.includes */ .gH.includes((activity === null || activity === void 0 ? void 0 : activity.activityTypeID) || -1)) {
            joinChatRoom(activity.chatRoom.id, activity.chatRoom.viewerIsMember);
        }
        if (!activity.isScrapped && ((ref1 = activity.manager) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.channel) === null || ref2 === void 0 ? void 0 : ref2.viewerHasFollowed) === false) {
            enqueueSnackbar("이 게시글을 등록한 기업을 팔로우했습니다.", {
                action: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_SnackbarLink_SnackbarLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    href: "/channel/".concat(activity.manager.channel.url)
                })
            });
        }
        // 스크랩을 모두 하나의 api에서 처리하기 때문에 스크랩 페이지에서 단건 삭제시에만 호출하도록 합니다
        if (isWebview) {
            activity.isScrapped ? fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportRemoveScrap") : fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportAddScrap");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            children({
                loading: loading,
                scrapActivity: scrapActivity,
                scrapCount: scrapCount
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_LoginAlert__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                DialogProps: {
                    open: showLoginAlert
                },
                onRequestClose: closeLoginAlert
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ActivityScrap);
graphql_tag__WEBPACK_IMPORTED_MODULE_3___default()(_templateObject());


/***/ }),

/***/ 39749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17563);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_chatting_chattingContext_type_chattingQueryParams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75551);
/* harmony import */ var components_AlertDialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13133);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  & > b,\n  strong {\n    font-size: 18px;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var LoginAlert = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var goLogin = function() {
        var next = props.chatRoomId ? "".concat(window.location.href, "?").concat(_app_feature_chatting_chattingContext_type_chattingQueryParams__WEBPACK_IMPORTED_MODULE_4__/* .CHAT_OPEN_TYPE_QUERY_KEY */ .v, "=").concat(_app_feature_chatting_chattingContext_type_chattingQueryParams__WEBPACK_IMPORTED_MODULE_4__/* .CHAT_OPEN_TYPE.DEFAULT */ .X.DEFAULT, "&chatRoomId=").concat(props.chatRoomId) : window.location.href;
        router.push("/login?".concat(query_string__WEBPACK_IMPORTED_MODULE_3__.stringify({
            next: next
        })));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_AlertDialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                    children: "로그인 후 이용가능한 서비스입니다."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("b", {
                    children: "로그인 하시겠습니까?"
                })
            ]
        }),
        onConfirm: goLogin,
        confirmLabel: "확인"
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginAlert);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "LoginAlert__StyledWrapper",
    componentId: "sc-de340b2b-0"
})(_templateObject());


/***/ }),

/***/ 65155:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    INVALID_REQUEST: "올바르지 않은 요청 입니다.",
    NO_RESPONSE_ERROR: "현재 서버에 응답이 없습니다. 잠시후 다시 시도해주세요",
    UNKNOWN_ERROR: "알 수 없는 오류가 발생했습니다.",
    FORBIDDEN: "요청할 수 있는 권한이 없습니다.",
    UNAUTHENTICATED: "계정이 인증되지 않았습니다. 로그인 확인 후 다시 시도해 보세요.",
    REQUIRED_LOGGED_IN: "로그인 후 사용할 수 있습니다.",
    NOT_FOUND_ERROR: "알 수 없는 오류가 발생했습니다.",
    ALREADY_EXISTING_EMAIL: "이미 가입된 이메일 입니다. 다른 이메일을 사용해주세요",
    ALREADY_EXISTING_NICKNAME: "이미 가입된 닉네임 입니다. 다른 닉네임을 사용해주세요",
    ALREADY_EXISTING_PHONE_NUMBER: "입력하신 휴대폰 번호는 이미 가입된 회원입니다.",
    INVALID_PHONE_NUMBER_FORMAT: "번호를 올바르게 입력해주세요",
    INVALID_AUTH_CODE: "인증번호가 일치하지 않습니다. 다시 확인해주세요.",
    ALREADY_JOINED_CHAT_ROOM: "이미 참여한 채팅방입니다.",
    TIMESPREAD_STATUS_REQUIRE_PARAMETER: "필요 파리미터 누락",
    TIMESPREAD_STATUS_OBJECT_NOT_EXIST: "일치하는 대상 없음",
    TIMESPREAD_STATUS_PHONE_ALREADY_AUTHORIZE: "이미 인증된 핸드폰 번호입니다.",
    TIMESPREAD_STATUS_PHONE_CODE_REQUEST_EXCEED: "휴대폰 인증 코드 요청 횟수가 초과 하였습니다.",
    TIMESPREAD_STATUS_PHONE_CODE_DATA_NOT_FOUND: "휴대폰 인증 코드 데이터 없음",
    TIMESPREAD_STATUS_PHONE_FAIL_AUTHORIZE: "휴대폰 인증에 실패 하였습니다.",
    TIMESPREAD_STATUS_PHONE_REQUEST_EXCEED: "휴대폰 인증 횟수가 초과 하였습니다.",
    TIMESPREAD_STATUS_PHONE_NOT_ACCEPTED_IP: "허용되지 않은 IP",
    TIMESPREAD_STATUS_PHONE_USER_DELETE: "탈퇴 후 7일 이후부터 휴대폰 인증 가능",
    TIMESPREAD_STATUS_LUCKYBOX_LIMIT_EXCEED: "행운상자 개수 초과",
    TIMESPREAD_STATUS_LUCKYBOX_NEED_CASH: "행운상자 도전 최소 캐시 필요",
    TIMESPREAD_STATUS_LUCKYBOX_ALREADY_OPEN: "이미 오픈된 상자",
    TIMESPREAD_STATUS_SCREEN_ALREADY_FINISH: "이미 종료된 꽉 잠금 모드"
});


/***/ }),

/***/ 25536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DK": function() { return /* binding */ ACTIVITY_TYPE_TEXT; },
/* harmony export */   "ID": function() { return /* binding */ ORDER_TEXT; },
/* harmony export */   "RO": function() { return /* binding */ ACTIVITY_TYPE_TEXT_ID; },
/* harmony export */   "T5": function() { return /* binding */ JOBTYPE_JSONLD; },
/* harmony export */   "VG": function() { return /* binding */ ACTIVITY_POST_SEARCH_ORDER_TEXT; },
/* harmony export */   "do": function() { return /* binding */ ACTIVITY_TYPE_ID_NAME; },
/* harmony export */   "fO": function() { return /* binding */ COMPANY_ANALYSIS_ORDER_TEXT; },
/* harmony export */   "g1": function() { return /* binding */ COMMUNITY_POST_SEARCH_ORDER_TEXT; },
/* harmony export */   "h0": function() { return /* binding */ COVER_LETTER_SEARCH_ORDER_TEXT; },
/* harmony export */   "i6": function() { return /* binding */ ORGANIZATIONS; },
/* harmony export */   "ic": function() { return /* binding */ USER_DELETE_REASON_TYPE_TEXT; },
/* harmony export */   "n2": function() { return /* binding */ ACTIVITY_LIST_ORDER_TEXT; }
/* harmony export */ });
/* unused harmony export JOBTYPE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);
/* harmony import */ var _enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35460);



var _obj;
var ORDER_TEXT = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.CREATED_AT */ .Ehb.CREATED_AT, "생성일순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.RECRUIT_CLOSE_AT */ .Ehb.RECRUIT_CLOSE_AT, "마감순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.RECENT */ .Ehb.RECENT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.SCRAP_COUNT */ .Ehb.SCRAP_COUNT, "최근 스크랩 증가순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.VIEW_COUNT */ .Ehb.VIEW_COUNT, "인기순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.REPLY_COUNT */ .Ehb.REPLY_COUNT, "지원자순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.DEAD_LINE */ .Ehb.DEAD_LINE, "마감일순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.STATUS_UPDATED_AT */ .Ehb.STATUS_UPDATED_AT, "수정일순"), _obj);
var _obj1;
var ACTIVITY_LIST_ORDER_TEXT = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.CREATED_AT */ .Ehb.CREATED_AT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.SCRAP_COUNT */ .Ehb.SCRAP_COUNT, "최근 스크랩 증가순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.VIEW_COUNT */ .Ehb.VIEW_COUNT, "최근 조회 증가순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.REPLY_COUNT */ .Ehb.REPLY_COUNT, "최근 댓글 증가순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.RECRUIT_CLOSE_AT */ .Ehb.RECRUIT_CLOSE_AT, "마감순"), _obj1);
var _obj2;
var ACTIVITY_POST_SEARCH_ORDER_TEXT = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.CREATED_AT */ .H1T.CREATED_AT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.VIEW_COUNT */ .H1T.VIEW_COUNT, "인기순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.SCRAP_COUNT */ .H1T.SCRAP_COUNT, "스크랩순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.RECRUIT_CLOSEAT */ .H1T.RECRUIT_CLOSEAT, "마감순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.RELEVANCE */ .H1T.RELEVANCE, "관련도순"), _obj2);
var _obj3;
var COMMUNITY_POST_SEARCH_ORDER_TEXT = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj3, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CommunityPostSearchOrderField.CREATED_AT */ .GK1.CREATED_AT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj3, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CommunityPostSearchOrderField.VIEW_COUNT */ .GK1.VIEW_COUNT, "인기순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj3, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CommunityPostSearchOrderField.RELEVANCE */ .GK1.RELEVANCE, "관련도순"), _obj3);
var _obj4;
var COVER_LETTER_SEARCH_ORDER_TEXT = (_obj4 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj4, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterOrderField.RELEVANCE */ .lNF.RELEVANCE, "관련도순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj4, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterOrderField.SCRAP_COUNT */ .lNF.SCRAP_COUNT, "스크랩순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj4, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterOrderField.PASSED_AT */ .lNF.PASSED_AT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj4, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterOrderField.RECENT_SCRAP_COUNT */ .lNF.RECENT_SCRAP_COUNT, "최근 인기순"), _obj4);
var _obj5;
var COMPANY_ANALYSIS_ORDER_TEXT = (_obj5 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj5, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .AnalysisReportOrderField.CREATED_AT */ ._kI.CREATED_AT, "최근 등록순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj5, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .AnalysisReportOrderField.IMPRESSION_COUNT */ ._kI.IMPRESSION_COUNT, "조회순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj5, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .AnalysisReportOrderField.SCRAP_COUNT */ ._kI.SCRAP_COUNT, "스크랩순"), _obj5);
var _obj6;
var ORGANIZATIONS = (_obj6 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.MAJOR_COMPANY */ .BRt.MAJOR_COMPANY, "대기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.SMALL_BUSINESS */ .BRt.SMALL_BUSINESS, "중소기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.PUBLIC_INSTITUTIONS */ .BRt.PUBLIC_INSTITUTIONS, "공공기관/공기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.FOREIGN_COMPANIES */ .BRt.FOREIGN_COMPANIES, "외국계기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.MIDSIZE_BUSINESS */ .BRt.MIDSIZE_BUSINESS, "중견기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.NON_PROFIT_ORGANIZATION */ .BRt.NON_PROFIT_ORGANIZATION, "비영리단체/협회/재단"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.START_UP */ .BRt.START_UP, "스타트업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.BANK */ .BRt.BANK, "금융권"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.HOSPITAL */ .BRt.HOSPITAL, "병원"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.CLUB */ .BRt.CLUB, "동아리/학생자치단체"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.ETC */ .BRt.ETC, "기타"), _obj6);
var _obj7;
var JOBTYPE = (_obj7 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj7, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.NEW */ .O4l.NEW, "신입"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj7, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.INTERN */ .O4l.INTERN, "인턴"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj7, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.EXPERIENCED */ .O4l.EXPERIENCED, "경력직"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj7, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.CONTRACT */ .O4l.CONTRACT, "계약직"), _obj7);
var _obj8;
/**
 * 네이버 서치어드바이저 `experienceRequirements` 가이드에 맞추어 인턴, 신입을 모두 **신입**으로 통일하고 경력직을 **경력**으로 통일합니다.
 *
 * https://searchadvisor.naver.com/guide/structured-data-job
 *
 * TODO : 추후 JOBTYPE을 다른곳에서 사용하지 않는다면 해당 상수를 삭제하고 JOBTYPE_JSONLD를 사용하는 곳에서 JOBTYPE을 사용하도록 변경합니다.
 */ var JOBTYPE_JSONLD = (_obj8 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj8, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.NEW */ .O4l.NEW, "신입"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj8, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.INTERN */ .O4l.INTERN, "신입"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj8, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.EXPERIENCED */ .O4l.EXPERIENCED, "경력"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj8, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.CONTRACT */ .O4l.CONTRACT, "계약직"), _obj8);
var _obj9;
var ACTIVITY_TYPE_TEXT = (_obj9 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY, "대외활동"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CLUB */ .kF.CLUB, "동아리"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, "공모전"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN, "인턴"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT, "채용"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION, "교육"), _obj9);
var _obj10;
var ACTIVITY_TYPE_ID_NAME = (_obj10 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.ACTIVITY */ .lY.ACTIVITY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CLUB */ .kF.CLUB, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.CLUB */ .lY.CLUB), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.CONTEST */ .lY.CONTEST), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.INTERN */ .lY.INTERN), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.RECRUIT */ .lY.RECRUIT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.EDUCATION */ .lY.EDUCATION), _obj10);
var _obj11;
var ACTIVITY_TYPE_TEXT_ID = (_obj11 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.ACTIVITY */ .lY.ACTIVITY, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.CLUB */ .lY.CLUB, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CLUB */ .kF.CLUB), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.CONTEST */ .lY.CONTEST, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.INTERN */ .lY.INTERN, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.RECRUIT */ .lY.RECRUIT, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.EDUCATION */ .lY.EDUCATION, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION), _obj11);
var _obj12;
var USER_DELETE_REASON_TYPE_TEXT = (_obj12 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.LOW_FREQUENCY_USES */ .BFP.LOW_FREQUENCY_USES, "사용빈도 낮음"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.POOR_UX_UI */ .BFP.POOR_UX_UI, "사이트 이용 불편"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.LACK_OF_CONTENT_QUALITY */ .BFP.LACK_OF_CONTENT_QUALITY, "콘텐츠 내용 부족"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.OUT_OF_JOB_MARKET */ .BFP.OUT_OF_JOB_MARKET, "대외활동/인턴/구직활동 종료"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.POOR_SECURITY */ .BFP.POOR_SECURITY, "개인정보 유출 우려"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.ETC */ .BFP.ETC, "기타"), _obj12);


/***/ }),

/***/ 96597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29496);
/* harmony import */ var utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29229);


function useErrorSnackbar() {
    var enqueueApolloError = function enqueueApolloError(error) {
        enqueueSnackbar((0,utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__/* .getErrorMessage */ .e$)(error), {
            // @ts-ignore
            "data-testid": "snackbar-apollo-error",
            // @ts-ignore
            "data-error-code": (0,utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__/* .getErrorCode */ .zg)(error)
        });
    };
    var enqueueErrorMessage = function enqueueErrorMessage(message) {
        enqueueSnackbar(message, {
            // @ts-ignore
            "data-testid": "snackbar-message-error"
        });
    };
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_0__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    return {
        enqueueApolloError: enqueueApolloError,
        enqueueErrorMessage: enqueueErrorMessage
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useErrorSnackbar);


/***/ }),

/***/ 29229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e$": function() { return /* binding */ getErrorMessage; },
/* harmony export */   "zg": function() { return /* binding */ getErrorCode; }
/* harmony export */ });
/* unused harmony export getErrorMessageFromServer */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65155);


var getErrorCode = function(error) {
    var errorCode = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(error, "graphQLErrors[0].extensions.code", "UNKNOWN_ERROR");
    return errorCode;
};
var getErrorMessage = function(error) {
    var errorCode = getErrorCode(error);
    var message = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(_constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, errorCode, _constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__/* ["default"].UNKNOWN_ERROR */ .Z.UNKNOWN_ERROR);
    return message;
};
var getErrorMessageFromServer = function(error) {
    var message = get(error, "graphQLErrors[0].message", errorMessages.UNKNOWN_ERROR);
    return message;
};


/***/ })

}]);